import React from "react";
import PolicyPageLayout, { PolicyList, PolicySection } from "./PolicyPageLayout";
import { COMPANY_DETAILS } from "./policyData";

const ShippingPolicy = () => {
  return (
    <PolicyPageLayout
      title="Shipping Policy"
      subtitle="This policy explains how physical product orders, repair pickups, dispatch timelines and delivery-related communication are handled on our website."
    >
      <PolicySection title="1. Service Area">
        <p>
          We currently process and deliver orders within India only, subject to
          courier serviceability and operational feasibility.
        </p>
      </PolicySection>

      <PolicySection title="2. Order Confirmation, Processing and Dispatch">
        <PolicyList
          items={[
            "Orders are processed only after successful order confirmation, stock availability check and, where applicable, payment authorisation.",
            "Confirmed product orders are typically processed within 1 to 3 business days and may take up to 5 business days in some cases.",
            "Dispatch timelines can vary during high-demand periods, public holidays, stock transfers, custom testing or quality-check requirements.",
            "If we cannot accept an order because of stock, verification, serviceability or technical reasons, we may cancel the order and process the applicable refund under our Refund Policy.",
          ]}
        />
      </PolicySection>

      <PolicySection title="3. Delivery Timeline">
        <p>
          After dispatch, delivery usually takes between 2 and 7 business days
          depending on destination, courier network and local conditions. Any
          delivery date displayed on the website is an estimate and not a
          guaranteed commitment.
        </p>
      </PolicySection>

      <PolicySection title="4. Shipping Partners and Tracking">
        <p>
          We may use registered domestic courier services, local delivery
          partners or postal services. Tracking details are shared when
          available.
        </p>
      </PolicySection>

      <PolicySection title="5. Shipping Charges">
        <p>
          Shipping, handling or pickup charges, if shown at checkout or
          confirmed before dispatch, will form part of the transaction amount.
          Such charges are generally non-refundable once dispatch or pickup has
          been arranged, except where refund is required because of our error or
          non-fulfilment.
        </p>
      </PolicySection>

      <PolicySection title="6. Inspection at Delivery">
        <PolicyList
          items={[
            "Please check the package condition at the time of delivery wherever possible.",
            "Visible transit damage, missing items or wrong-product issues should be reported to us as soon as possible, preferably within 24 hours of delivery.",
            "We may ask for clear photos, video, invoice details and package labels to investigate a delivery issue.",
          ]}
        />
      </PolicySection>

      <PolicySection title="7. Delivery Address and Failed Attempts">
        <PolicyList
          items={[
            "You are responsible for providing a complete and accurate delivery address and reachable phone number.",
            "If delivery fails due to an incorrect address, repeated non-availability or refusal to accept the package, re-dispatch or handling charges may apply.",
            "We may contact you to verify address, KYC or order details before dispatching high-value items.",
          ]}
        />
      </PolicySection>

      <PolicySection title="8. Repair Services, Pickup and Drop">
        <p>
          For repair services, doorstep pickup, delivery or service completion
          timelines depend on diagnosis, spare-part availability, customer
          approval and local support coverage. Our team will confirm the
          applicable schedule directly with you.
        </p>
      </PolicySection>

      <PolicySection title="9. Delays Outside Our Control">
        <p>
          We are not responsible for courier delays, weather disruption, strikes,
          route restrictions, natural events, payment verification delays or
          other circumstances beyond our reasonable control. We will still try
          to assist you in tracking and resolving such cases.
        </p>
      </PolicySection>

      <PolicySection title="10. Shipping Support Contact">
        <p>
          For dispatch updates, address correction requests or delivery-related
          support, contact {COMPANY_DETAILS.name} at {COMPANY_DETAILS.email} or{" "}
          {COMPANY_DETAILS.phone} during {COMPANY_DETAILS.supportHours}.
        </p>
      </PolicySection>
    </PolicyPageLayout>
  );
};

export default ShippingPolicy;
